import * as t from 'io-ts'
import { isInteger } from 'lodash';

const stringInt = new t.Type<number, number, unknown>(
    'stringInt',
    (input: unknown): input is number => typeof input === 'string' && isInteger(parseInt(input)),
    (input, context) => typeof input === 'string' && isInteger(parseInt(input)) 
        ? t.success(parseInt(input)) 
        : t.failure(input, context),
    t.identity
);

const numberInt = new t.Type<number, number, unknown>(
    'numberInt',
    (input: unknown): input is number => typeof input === 'number' && isInteger(input),
    (input, context) => typeof input === 'number' && isInteger(input) 
        ? t.success(input) 
        : t.failure(input, context),
    t.identity
);

const stringIntCodec = t.union([stringInt, numberInt]);

export default stringIntCodec;